exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fab-tooltip.tooltip {\n    display: block !important;\n    padding: 4px;\n    z-index: 10000;\n}\n.fab-tooltip.tooltip .tooltip-inner {\n    background: #333333;\n    color: white;\n    border-radius: 0px;\n    padding: 5px 10px 4px;\n}\n.fab-tooltip.tooltip tooltip-arrow {\n    display: none;\n}\n.fab-tooltip.tooltip[aria-hidden='true'] {\n    visibility: hidden;\n    opacity: 0;\n    -webkit-transition: opacity .15s, visibility .15s;\n    transition: opacity .15s, visibility .15s;\n}\n.fab-tooltip.tooltip[aria-hidden='false'] {\n    visibility: visible;\n    opacity: 1;\n    -webkit-transition: opacity .15s;\n    transition: opacity .15s;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00c57f94","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-fab/src/FAB.vue
// module id = 2vSK
// module chunks = 4